<!-- email-editor.component.html -->
<div class="cnt">
  <!-- Loading indicator -->
  <div *ngIf="isLoading" class="loading-container">
    <div class="loading-bar">
      <div class="loading-progress"></div>
    </div>
    <div class="loading-text">Loading email editor...</div>
  </div>

  <div class="editor-container" [class.hidden]="isLoading">
    <div class="editor-toolbar mat-elevation-z2">
      <div class="toolbar-left">
        <div class="toolbar">
          <button class="template-btn" (click)="openTemplatesPanel()">
            <mat-icon style="color: white;">bento</mat-icon>
          </button>
          <!-- Add more buttons as needed -->
        </div>
      </div>
    
      <div class="toolbar-right">
        <!-- Other Fields Button with Material Menu -->
        <button type="button" mat-button [matMenuTriggerFor]="otherFieldsMenu" #otherFieldsMenuTrigger="matMenuTrigger"
          class="fields-btn">
          Other fields
          <mat-icon>arrow_drop_down</mat-icon>
        </button>
        <mat-menu #otherFieldsMenu="matMenu" class="fields-menu">
          <ng-container *ngFor="let otherField of otherFields">
            <button mat-menu-item (click)="onTagSelect(otherField)">
              <span>{{otherField.label}}</span>
              <mat-icon class="settings-button" (click)="onSettingsClick($event, otherField, otherFieldsMenuTrigger)"
                matTooltip="Settings">
                settings
              </mat-icon>
            </button>
          </ng-container>
        </mat-menu>
    
        <!-- Leads Button with Material Menu -->
        <button type="button" mat-button [matMenuTriggerFor]="leadsMenu" #leadsMenuTrigger="matMenuTrigger"
          class="leads-btn">
          Leads
          <mat-icon>arrow_drop_down</mat-icon>
        </button>
        <mat-menu #leadsMenu="matMenu" class="leads-menu">
          <ng-container *ngFor="let leads of leadTags">
            <button mat-menu-item (click)="onTagSelect(leads)">
              <span>{{leads.label}}</span>
              <mat-icon class="settings-button" (click)="onSettingsClick($event, leads, leadsMenuTrigger)"
                matTooltip="Settings">
                settings
              </mat-icon>
    
            </button>
          </ng-container>
        </mat-menu>
    
        <!-- Recent Button with Material Menu -->
        <button type="button" mat-button [matMenuTriggerFor]="recentMenu" #recentMenuTrigger="matMenuTrigger"
          class="recent-btn">
          Recent
          <mat-icon>arrow_drop_down</mat-icon>
        </button>
        <mat-menu #recentMenu="matMenu" class="recent-menu">
          <ng-container *ngFor="let rec of recent">
            <button mat-menu-item (click)="onTagSelect(rec)">
              <span>{{rec.label}}</span>
            </button>
          </ng-container>
        </mat-menu>
      </div>
    </div>
  </div>
  <div class="cnt-body" [class.hidden]="isLoading">
    <div #editorContainer class="editor"></div>
  </div>
</div>